// src/components/EditPaymentLinkDialog.js
import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

const EditPaymentLinkDialog = ({ open, onClose, link, onEdit }) => {
  const [appName, setAppName] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [expiresAt, setExpiresAt] = useState("");

  useEffect(() => {
    if (link) {
      setAppName(link.app_name);
      setLinkUrl(link.link);
      setExpiresAt(link.expires_at);
    }
  }, [link]);

  const handleEdit = () => {
    if (!appName || !linkUrl || !expiresAt) {
      alert("すべてのフィールドを入力してください。");
      return;
    }
    onEdit({
      id: link.id,
      app_name: appName,
      link: linkUrl,
      expires_at: expiresAt,
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>送金URLを編集</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="dense" required>
          <InputLabel>アプリ名</InputLabel>
          <Select
            value={appName}
            onChange={(e) => setAppName(e.target.value)}
            label="アプリ名"
          >
            <MenuItem value="PayPay">PayPay</MenuItem>
            <MenuItem value="PayPal">PayPal</MenuItem>
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          label="リンク"
          type="text"
          fullWidth
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
        />
        <TextField
          margin="dense"
          label="有効期限"
          type="datetime-local"
          fullWidth
          value={expiresAt}
          onChange={(e) => setExpiresAt(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          キャンセル
        </Button>
        <Button onClick={handleEdit} color="primary">
          保存
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditPaymentLinkDialog;
